import { AutoAwesomeOutlined, MoreVert } from "@mui/icons-material";
import { Box, IconButton, Menu, MenuItem, Paper, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import { grey, indigo } from "../../../../colors";

// Shared card shell for both the clarifying-questions and assumed-questions modules: the
// reasoning header, the optional "more options" menu, and the content passed as children.
export default function ClarifyingContainer({
  reasoning,
  answered,
  onSkipAndTurnOff,
  children,
}: {
  reasoning?: string | null;
  answered?: boolean;
  onSkipAndTurnOff?: () => void;
  children: React.ReactNode;
}) {
  const [moreAnchor, setMoreAnchor] = useState<null | HTMLElement>(null);

  return (
    <Paper
      elevation={0}
      sx={{
        p: "1.25em",
        borderRadius: "1em",
        border: `1px solid ${indigo[100]}`,
        backgroundColor: indigo[50],
        position: "relative",
      }}
    >
      {onSkipAndTurnOff && !answered && (
        <>
          <Box sx={{ position: "absolute", top: "0.5em", right: "0.5em" }}>
            <Tooltip title="More options">
              <IconButton size="small" onClick={(e) => setMoreAnchor(e.currentTarget)} sx={{ color: grey[500] }}>
                <MoreVert fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
          <Menu
            anchorEl={moreAnchor}
            open={Boolean(moreAnchor)}
            onClose={() => setMoreAnchor(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            slotProps={{ paper: { sx: { borderRadius: "12px", minWidth: 260 } } }}
          >
            <MenuItem
              onClick={() => {
                setMoreAnchor(null);
                onSkipAndTurnOff();
              }}
              sx={{ fontSize: "0.875rem" }}
            >
              Skip and turn off clarifying questions
            </MenuItem>
          </Menu>
        </>
      )}

      <Box display="flex" gap="0.6em" alignItems="flex-start" mb={reasoning ? "1em" : 0}>
        <AutoAwesomeOutlined sx={{ fill: indigo[500], fontSize: 20, mt: "2px", flexShrink: 0 }} />
        <Typography variant="body2" color={indigo[900]} sx={{ lineHeight: 1.5 }}>
          {reasoning || "A little more context would help me give you a better answer."}
        </Typography>
      </Box>
      {children}
    </Paper>
  );
}
